import { Flex, FormControl, FormLabel, Input, InputGroup, InputLeftElement, InputProps, Text } from '@chakra-ui/react'
import { MdClose, MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'

interface iFormProps extends InputProps {
  label?: string
  OnChange: (e: string) => void
  OnRemove?: () => void
  errorMessage?: string
  error?: boolean
  readOnly?: boolean
  themeWhite?: boolean
  extraLabel?: any
  fontSize?: string
  InputLeftGroup?: string
  step?: string
  onMoveUp?: () => void
  onMoveDown?: () => void
}

export const InputCmp: React.FC<iFormProps> = ({
  label,
  extraLabel,
  error,
  themeWhite,
  readOnly,
  errorMessage,
  OnChange,
  width,
  type,
  w,
  pl,
  fontSize,
  InputLeftGroup,
  OnRemove,
  step,
  onMoveUp,
  onMoveDown,
  ...rest
}) => {
  return (
    <FormControl width={width ?? w ?? '100%'}>
      {label && (
        <FormLabel
          pos="relative"
          mr="0"
          color={themeWhite ? 'var(--c1)' : 'var(--Gray1)'}
          fontSize="14px"
          mb=".25rem"
          wordBreak="keep-all"
        >
          {label} {extraLabel}
        </FormLabel>
      )}

      <InputGroup size="sm" position="relative">

        {InputLeftGroup && (
          <InputLeftElement pointerEvents="none" color="var(--Gray3)" fontWeight="semibold" bg="var(--c2)" border="1px solid var(--c6)" height="1.925rem" fontSize="0.85rem">
            {InputLeftGroup}
          </InputLeftElement>
        )}
        <Input
          readOnly={readOnly}
          pl={InputLeftGroup ? '2.25rem' : pl}
          {...rest}
          step={step}
          bg={themeWhite ? 'var(--c1)' : ''}
          fontSize={fontSize ?? '.875rem'}
          height="1.925rem"
          type={type ?? 'text'}
          width={width}
          onChange={(e) => OnChange(e.target.value)}
          _focus={{ boxShadow: '0 0 0 1px #3182ce !important' }}
          borderColor="var(--Gray4)"
        />

        <Flex pos="absolute" top="50%" transform="translate(0,-50%)" right="8px" gap="6px" align="center">
          {onMoveUp && (
            <Flex cursor="pointer" onClick={onMoveUp}>
              <MdKeyboardArrowUp />
            </Flex>
          )}

          {onMoveDown && (
            <Flex cursor="pointer" onClick={onMoveDown}>
              <MdKeyboardArrowDown />
            </Flex>
          )}

          {OnRemove && (
            <Flex color="var(--Red)" _hover={{ color: 'var(--Red-hover)' }} cursor="pointer" onClick={OnRemove}>
              <MdClose />
            </Flex>
          )}
      </Flex>
    </InputGroup>

      {error && errorMessage && (
        <Text mt=".125rem" color="var(--Red)" pl=".125rem" fontSize=".75rem">
          {errorMessage}
        </Text>
      )}
    </FormControl>
  )
}
